/**
 * Makes the Expanding Text elemental block work
 * Also handles the Safety Data Sheets dropdowns,
 * which have the same action but are not Elemental blocks
 */
class ExpandingTextBlock {
  constructor() {
    this.exp = document.querySelectorAll(
      ".block-exptext--title, .ds-brand--title",
    );

    this.events();
  }

  events() {
    this.exp.forEach((block) => {
      block.addEventListener("click", this.expand.bind(this));
    });
  }

  /**
   * Reveals block content
   * @param {Event} e
   */
  expand(e) {
    e.stopPropagation();
    const title = e.currentTarget; // The clicked title element
    const block = title.closest(".block-exptext") || title.closest(".ds-brand");

    if (!block) return;

    const baseElement = block.classList.contains("block-exptext")
      ? "block-exptext"
      : "ds-brand";
    const open = document.querySelectorAll(`.${baseElement}--open`);

    open.forEach((openBlock) => {
      if (openBlock === block) return;
      openBlock.classList.remove(`${baseElement}--open`);
    });
    block.classList.toggle(`${baseElement}--open`);
    // block.scrollIntoView({
    //   behavior: "smooth",
    // });
  }
}

export default ExpandingTextBlock;
